import { render, staticRenderFns } from "./IndexMobile.vue?vue&type=template&id=b049f83e&scoped=true"
import script from "./IndexMobile.vue?vue&type=script&lang=js"
export * from "./IndexMobile.vue?vue&type=script&lang=js"
import style0 from "./IndexMobile.vue?vue&type=style&index=0&id=b049f83e&prod&scoped=true&lang=scss"
import style1 from "./IndexMobile.vue?vue&type=style&index=1&id=b049f83e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b049f83e",
  null
  
)

export default component.exports